import {
  legacy_createStore as createStore,
  applyMiddleware,
  combineReducers,
  Middleware,
} from "redux";
import { thunk } from "redux-thunk";
import logger from "redux-logger";

// Reducers
import HelpCenterReducer from "./help-center/reducer";

const rootReducer = combineReducers({
  helpCenter: HelpCenterReducer,
});

let middleware: Middleware[] = [thunk];

if (process.env.NODE_ENV !== "production") {
  middleware = [...middleware, logger];
}

export type AppState = ReturnType<typeof rootReducer>;
export default createStore(
  rootReducer,
  window["__STATE__"],
  applyMiddleware(...middleware)
);
